/* hook up in mapsherpa */
(function($) {

  var qs = (function(a) {
    if (a === "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i) {
      var p = a[i].split('=', 2);
      if (p.length == 1) {
        b[p[0]] = "";
      } else {
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
      }
    }
    return b;
  })(window.location.search.substr(1).split('&'));

  var allProducts;
  var productIds = [];
  var pageSizes = [];
  var spinner;
  var $spinEl;

  // function resize() {}
  // $(window).resize(resize);

  $(document).ready(function() {
    $spinEl = $('.js-spinner');

    spinner = new Spinner({
      lines: 11,
      length: 20,
      width: 10,
      radius: 20,
      corners: 1,
      rotate: 0,
      direction: 1,
      color: '#000',
      speed: 1,
      trail: 60,
      shadow: false,
      hwaccel: false,
      className: 'spinner',
      zIndex: 2e9,
      top: 0,
      left: 0
    });

    if (qs.q) {
      $spinEl.show();
      spinner.spin($spinEl[0]);
      $('.js-search-result-title').html('Searching for ' + leftQuote + qs.q + rightQuote).show();
    }
    // resize();

    $.ajax({
      url: 'https://'+Shopify.shop+'/products.json?limit=250&product_type=on-demand',
      dataType: 'jsonp',
      success: function(data) {
        allProducts = data.products;
        data.products.forEach(function(product) {
          if (!product.variants.length) {
            return;
          }
          var id = product.variants[0].sku.split('-')[0];
          product.variants.forEach(function(variant) {
            var size = variant.sku.split('-')[1];
            if (pageSizes.indexOf(size) == -1) {
              pageSizes.push(size);
            }
          });
          productIds.push(id);
        });
      }
    });

    if (mapsherpa.initialized) {
      mapsherpaSetup();
    } else {
      mapsherpa.on('initialized', mapsherpaSetup);
    }

  });

  function mapsherpaSetup() {

    if (qs.id && qs.type) {
      doOSMLookup(qs.id, qs.type);
    } else if (qs.q) {
      doSearch(qs.q);
    }

    function showFirstResult(data) {
      if (data.length === 0) {
        spinner.stop($spinEl[0]);
        $spinEl.hide();
        $('.js-search-result-title').empty().css({display: 'block'}).html('No Maps Found');
        $('.js-search-result-error').css({display: 'block'});
      } else {
        var first = null;
        data.forEach(function(result) {
          if (!first && result.osm_id) {
            first = result;
          }
        });
        if (first) {
          var bbox;
          if (first.boundingbox) {
            bbox = first.boundingbox;
          } else if (qs.bbox) {
            first.boundingbox = qs.bbox;
            bbox = qs.bbox.split(',');
          }
          if (bbox) {
            first.bounds = [[parseFloat(bbox[0]),parseFloat(bbox[2])], [parseFloat(bbox[1]), parseFloat(bbox[3])]];
            currentSearchResult = first;
            findProductsFromSearch(true);
          } else {
            // TODO: what to do?
          }
        } else {
          // TODO: what to do?
        }
      }
    }

    function searchNoResults() {
      alert('no results');
    }

    function doOSMLookup(id, type) {
      $.ajax({
        url: '//nominatim.openstreetmap.org/reverse.php',
        data: {
          addressdetails: 1,
          osm_id: id,
          osm_type: type,
          format: 'json'
        },
        jsonp: 'json_callback',
        dataType: 'jsonp'
      }).then(
        function(result) {
          showFirstResult([result]);
        },
        searchNoResults
      );
    }

    function doSearch(term) {
      if (term) {
        trackEvent('Search', term);
        $.ajax({
          url: '//nominatim.openstreetmap.org/search',
          data: {
            limit: 20,
            addressdetails: 1,
            format: 'json',
            q: term
          },
          jsonp: 'json_callback',
          dataType: 'jsonp'
        }).then(
          showFirstResult,
          searchNoResults
        );
      }
    }

    function tpl(format, params) {
      var matches = format.match(/\$\{([\s\S]+?)\}/g) || []; // matches ${<name>}
      var result = format.slice();
      matches.forEach(function(match) {
        var key = match.substring(2,match.length - 1);
        if (params[key] !== undefined) {
          result = result.replace(match, params[key]);
        }
      });
      return result;
    }

    function findProductsFromSearch(autoLayout) {
      var data = currentSearchResult;
      $('.js-search-result-error').css({display: 'none'});
      $('.js-search-result-list').empty().css({display: 'block'});
      if (!data) {
        $('.js-search-result-title').empty().css({display: 'block'}).html('No Maps Found');
        $('.js-search-result-error').css({display: 'block'});
        // console.error('no current search result');
        return;
      }

      var searchOpts = {
        workflow: 'general',
        ids: productIds,
        pageSizes: pageSizes
      };

      if (data.address && data.address.country_code) {
        searchOpts.countryCode = data.address.country_code.toUpperCase();
      }

      var newResults = mapsherpa.findProductsForExtent(data.bounds, searchOpts);

      spinner.stop($spinEl[0]);
      $spinEl.hide();

      var fixedResults = {};
      newResults.forEach(function(result) {
        if (!fixedResults[result.product.id]) {
          fixedResults[result.product.id] = result;
          fixedResults[result.product.id].sizes = [];
        }
        fixedResults[result.product.id].sizes.push(result.size);
      });

      var results = [];
      for (var i in fixedResults) {
        results.push(fixedResults[i]);
      }
      $('.js-search-result-title').empty().css({display: 'block'}).html('We found ' + results.length + ' Maps for ' + leftQuote +  data.display_name + rightQuote);

      var template = $('#search-template').html();
      results.forEach(function(result, index) {
        var product;
        allProducts.forEach(function(p) {
          var id = p.variants[0].sku.split('-')[0];
          if (id == result.product.id) {
            product = p;
          }
        });

        // console.log(product);

        // calculate the smallest available price for sizes that match
        var amount = parseFloat(product.variants[0].price);
        var paperSize = product.variants[0].option1;
        var variantTitle = product.variants[0].title;
        result.sizes.forEach(function(size) {
          product.variants.forEach(function(variant) {
            var price = parseFloat(variant.price);
            if (variant.sku.split('-')[1] == size && price < amount) {
              amount = price;
              paperSize = variant.option1;
              variantTitle = variant.title;
            }
          });
        });
        var href = '/products/'+product.handle;
        var components = [];
        components.push('id='+encodeURIComponent(data.osm_id));
        components.push('type='+encodeURIComponent(data.osm_type.substring(0,1).toUpperCase()));
        components.push('bbox='+encodeURIComponent(data.boundingbox));
        if (paperSize) {
          components.push('s='+encodeURIComponent(paperSize));
          var orientation = mapsherpa.bestLayoutForProductExtent(data.bounds, result.product.id);
          components.push('o=' + encodeURIComponent(orientation));
        }
        var text = $(product.body_html).text().substring(0,128) + '... <a href="' + href + '?' + components.join('&') + '"><i class="icon-circle-arrow-right"></i></a>';
        var img = '<div class="image_placeholder">' + product.title + '</div>';
        if (product.images.length) {
          var src = product.images[0].src;
          var lastDot = src.lastIndexOf(".");
          src = src.slice(0, lastDot) + "_small" + src.slice(lastDot);
          img = '<img src="'+ src +'" class="media-object thumbnail">';
        }
        var opts = {
          idx: index,
          href: href + '?' + components.join('&'),
          img: img,
          title: currentSearchResult.display_name,
          productTitle: product.title,
          productDescription: text,
          productVendor: product.vendor,
          variantTitle: variantTitle,
          amount: Math.round(amount * 100),
          priceTable: createPriceTable(product, data, result.product.id)
        };
        var html = $('<div>').html(tpl(template, opts));
        $('.js-search-result-list').append(html.children());
      });
      Currency.convertAll(shopCurrency, Currency.currentCurrency);
      $("[data-content-element].js-popover").each(function() {
        $(this).popover({
          html: true,
          content: function() {
            return $($(this).attr('data-content-element')).html();
          }
        });
        $(this).click(function (e) { e.stopPropagation(); });
      });
    }

    function createPriceTable(product, data, productId) {
      var materials = [];
      var prices = {};
      var sizes = [];
      var variant;
      var href;
      var components;
      var orientation;
      var i;
      var hrefs = [];


      var $priceTable = $('#price-table-template');

      var withCurrency = $priceTable.hasClass('with-currency');
      var $head = $('<thead>');
      var $headRow = $('<tr></tr>');
      $headRow.append('<th></th>');
      $head.append($headRow);
      var $body = $('<tbody></tbody>');

      for (i=0; i<product.variants.length; i++) {
        variant = product.variants[i];

        if (materials.indexOf(variant.option2) == -1) {
          materials.push(variant.option2);
          $headRow.append('<th>'+variant.option2+'</th>');
        }
        if (sizes.indexOf(variant.option1) == -1) {
          sizes.push(variant.option1);
        }
        if (!prices[variant.option1]) {
          prices[variant.option1] = {};
          hrefs[variant.option1] = {};
        }
        if (!prices[variant.option1][variant.option2]) {
          prices[variant.option1][variant.option2] = variant.price;

          href = '/products/'+product.handle;
          components = [];
          components.push('id='+encodeURIComponent(data.osm_id));
          components.push('type='+encodeURIComponent(data.osm_type.substring(0,1).toUpperCase()));
          components.push('bbox='+encodeURIComponent(data.boundingbox));
          components.push('s='+encodeURIComponent(variant.option1));
          orientation = mapsherpa.bestLayoutForProductExtent(data.bounds, productId);
          components.push('o=' + encodeURIComponent(orientation));
          hrefs[variant.option1][variant.option2] = href + '?' + components.join('&');
        }
      }

      for (i=0; i<sizes.length; i++) {
        var $row = $('<tr></tr>');
        $row.append('<td><strong>'+sizes[i]+'</strong></td>');
        for (var j=0; j<materials.length; j++) {
          var price = prices[sizes[i]][materials[j]];
          href = hrefs[sizes[i]][materials[j]];
          if (price === undefined) {
            price = '--';
            href = 'javascript:void(0);';
          } else {
            price = '<a href="'+href+'"><span class="money">'+ price +'</span></a>';
          }
          $row.append('<td>'+price+'</td>');
        }
        $body.append($row);
      }

      return tpl($priceTable.html(), {
        tableHead: $head.html(),
        tableBody: $body.html()
      });
    }

  }

  function trackEvent(action, id, nonInteractive) {
    _gaq.push(['_trackEvent', 'MapSherpa OnDemand', action, id, null, nonInteractive]);
  }

})(window.jQuery);